import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ArchitectureDiagramProps {
  architecture: {
    frontend?: string;
    backend?: string;
    auth?: string;
    database?: string;
    storage?: string;
    queue?: string;
    hosting?: string;
  };
}

export const ArchitectureDiagram = ({ architecture }: ArchitectureDiagramProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Architecture Overview</CardTitle>
      </CardHeader>
      <CardContent>
        <svg viewBox="0 0 800 400" className="w-full h-auto">
          {/* Client Layer */}
          <g>
            <rect x="50" y="50" width="180" height="80" rx="8" fill="hsl(var(--primary))" opacity="0.1" stroke="hsl(var(--primary))" strokeWidth="2"/>
            <text x="140" y="95" textAnchor="middle" fill="hsl(var(--foreground))" fontSize="14" fontWeight="bold">Frontend</text>
            <text x="140" y="115" textAnchor="middle" fill="hsl(var(--muted-foreground))" fontSize="12">{architecture.frontend || "React"}</text>
          </g>

          {/* Auth Layer */}
          <g>
            <rect x="310" y="30" width="180" height="60" rx="8" fill="hsl(var(--secondary))" stroke="hsl(var(--border))" strokeWidth="2"/>
            <text x="400" y="55" textAnchor="middle" fill="hsl(var(--foreground))" fontSize="14" fontWeight="bold">Authentication</text>
            <text x="400" y="75" textAnchor="middle" fill="hsl(var(--muted-foreground))" fontSize="12">{architecture.auth || "Supabase Auth"}</text>
          </g>

          {/* Backend Layer */}
          <g>
            <rect x="310" y="120" width="180" height="80" rx="8" fill="hsl(var(--accent))" opacity="0.3" stroke="hsl(var(--border))" strokeWidth="2"/>
            <text x="400" y="155" textAnchor="middle" fill="hsl(var(--foreground))" fontSize="14" fontWeight="bold">Backend</text>
            <text x="400" y="175" textAnchor="middle" fill="hsl(var(--muted-foreground))" fontSize="12">{architecture.backend || "Edge Functions"}</text>
          </g>

          {/* Database Layer */}
          <g>
            <rect x="570" y="50" width="180" height="80" rx="8" fill="hsl(var(--primary))" opacity="0.1" stroke="hsl(var(--primary))" strokeWidth="2"/>
            <text x="660" y="85" textAnchor="middle" fill="hsl(var(--foreground))" fontSize="14" fontWeight="bold">Database</text>
            <text x="660" y="105" textAnchor="middle" fill="hsl(var(--muted-foreground))" fontSize="12">{architecture.database || "PostgreSQL"}</text>
          </g>

          {/* Storage Layer */}
          <g>
            <rect x="570" y="160" width="180" height="60" rx="8" fill="hsl(var(--secondary))" stroke="hsl(var(--border))" strokeWidth="2"/>
            <text x="660" y="185" textAnchor="middle" fill="hsl(var(--foreground))" fontSize="14" fontWeight="bold">Storage</text>
            <text x="660" y="205" textAnchor="middle" fill="hsl(var(--muted-foreground))" fontSize="12">{architecture.storage || "Object Storage"}</text>
          </g>

          {/* Queue/Cron Layer */}
          <g>
            <rect x="310" y="240" width="180" height="60" rx="8" fill="hsl(var(--accent))" opacity="0.3" stroke="hsl(var(--border))" strokeWidth="2"/>
            <text x="400" y="265" textAnchor="middle" fill="hsl(var(--foreground))" fontSize="14" fontWeight="bold">Scheduled Tasks</text>
            <text x="400" y="285" textAnchor="middle" fill="hsl(var(--muted-foreground))" fontSize="12">{architecture.queue || "Cron Jobs"}</text>
          </g>

          {/* Hosting Info */}
          <g>
            <rect x="50" y="260" width="180" height="40" rx="8" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="1" strokeDasharray="4"/>
            <text x="140" y="285" textAnchor="middle" fill="hsl(var(--muted-foreground))" fontSize="12">Hosted on: {architecture.hosting || "Cloud"}</text>
          </g>

          {/* Arrows */}
          {/* Frontend to Auth */}
          <line x1="230" y1="70" x2="310" y2="60" stroke="hsl(var(--border))" strokeWidth="2" markerEnd="url(#arrowhead)"/>
          
          {/* Frontend to Backend */}
          <line x1="230" y1="110" x2="310" y2="150" stroke="hsl(var(--border))" strokeWidth="2" markerEnd="url(#arrowhead)"/>
          
          {/* Backend to Database */}
          <line x1="490" y1="140" x2="570" y2="100" stroke="hsl(var(--border))" strokeWidth="2" markerEnd="url(#arrowhead)"/>
          
          {/* Backend to Storage */}
          <line x1="490" y1="180" x2="570" y2="190" stroke="hsl(var(--border))" strokeWidth="2" markerEnd="url(#arrowhead)"/>
          
          {/* Backend to Cron */}
          <line x1="400" y1="200" x2="400" y2="240" stroke="hsl(var(--border))" strokeWidth="2" markerEnd="url(#arrowhead)"/>

          {/* Arrow marker definition */}
          <defs>
            <marker id="arrowhead" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
              <polygon points="0 0, 10 3, 0 6" fill="hsl(var(--border))" />
            </marker>
          </defs>
        </svg>
      </CardContent>
    </Card>
  );
};
